::ng-deep particle-case-content{display:flex;width:100%}::ng-deep particle-case-content .pos-relative{height:initial}
/*# sourceMappingURL=case-content.component-AHPV737Z.css.map */
